import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("tr", null, [
        _createElementVNode("td", null, _toDisplayString(_ctx.location.id), 1),
        _createElementVNode("td", null, _toDisplayString(_ctx.location.name), 1)
    ]));
}
